import * as React from 'react';

import { LOCALE } from 'features/ui/enums';
import { StageStatus } from 'features/search/filters/enums';
import { renderInhabitDate } from 'features/services/utils/date-helpers';
import {getFormattedMessage} from 'features/services/utils/language-helper';
import {getCurrentLocale, getLocalizedPrice} from 'features/services/utils/env-helper';

import './style.scss';

import { Facts } from '.';
import {QuickFactsItem} from './item';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- viewModel varies by page type
    viewModel: any;
    addressString: string;
}

export const ParkingQuickFacts: React.FunctionComponent<Props> = ({ 
    viewModel, addressString
}) => {
    const getStageStatusLabel = () => {
        switch (viewModel.stageStatus) {
            case StageStatus.FORSALE:
                return getFormattedMessage('jm.components.ResidenceTags.forsale');
            case StageStatus.VIP:
                return getFormattedMessage('jm.components.ResidenceTags.vipSale');
            case StageStatus.PLANNED:
                return getFormattedMessage('jm.components.ResidenceTags.planned');
            case StageStatus.SOLD_OUT:
                return getFormattedMessage('jm.components.ResidenceTags.soldout');
            case StageStatus.PRESELLING:
                return getFormattedMessage('jm.components.ResidenceTags.preSelling');
            case StageStatus.REFERENCE:
                return getFormattedMessage('jm.components.ResidenceTags.reference');
            case StageStatus.MOVE_IN_READY:
                return getFormattedMessage('jm.components.ResidenceTags.moveInReady');
            case StageStatus.SUCCESSION:
                return getFormattedMessage('jm.components.ResidenceTags.succession');
            default:
                return getFormattedMessage('jm.components.ResidenceTags.forsale');
        }
    };

    const facts : Facts[] = [
        {key: 'address', devCounter: '01', 
            label: getFormattedMessage('jm.components.QuickFacts.address'), 
            fact: addressString, 
            condition: Boolean(addressString) 
        },
        {key: 'fiMinMaxTotalPrice', devCounter: '02',
            label: 'Velaton hinta', 
            fact: (viewModel.jmoyTotalPriceMax && (viewModel.jmoyTotalPriceMin !== viewModel.jmoyTotalPriceMax)) 
                ? getLocalizedPrice(viewModel.jmoyTotalPriceMin) + ' - ' + getLocalizedPrice(viewModel.jmoyTotalPriceMax)
                : getLocalizedPrice(viewModel.jmoyTotalPriceMin),
            tooltip:'Myyntihinta + lainaosuus', 
            condition: viewModel.jmoyTotalPriceMin && viewModel.jmoyTotalPriceMin !== 0
        },
        {key: 'inhabitDate', devCounter: '03',  
            label: getFormattedMessage('jm.components.QuickFacts.parkingInhabitDate'), 
            fact: renderInhabitDate(
                viewModel.inhabitDate, 
                viewModel.inhabitDateEnd, 
                viewModel.inhabitDateDetermined, 
                false, 
                false, 
                viewModel.inhabitDateRenderFull
            ), 
            condition: viewModel.inhabitDate 
        },
        {key: 'minMaxPrice', devCounter: '04', 
            label: getFormattedMessage('jm.components.QuickFacts.price'), 
            fact: (viewModel.maxPrice && (viewModel.minPrice !== viewModel.maxPrice)) 
                ? `${getLocalizedPrice(viewModel.minPrice)} - ${getLocalizedPrice(viewModel.maxPrice)}` 
                : `${getLocalizedPrice(viewModel.minPrice)}`, 
            tooltip: getCurrentLocale() === LOCALE.FI
                ? 'Ennen muuttoa maksettava kauppahinta'
                : undefined,
            condition: !viewModel.isSoldOut && viewModel.minPrice && viewModel.minPrice !== 0
        },
        {key: 'nrOfParkingSpots', devCounter: '05',  
            label: getFormattedMessage('jm.components.QuickFacts.parkingSpots'), 
            fact: viewModel.nrOfParkingSpots, 
            condition: (viewModel.nrOfParkingSpots !== 0 && viewModel.nrOfParkingSpots !== null && typeof viewModel.nrOfParkingSpots !== 'undefined') 
        },
        {key: 'projectStatus', devCounter: '06',  
            label: 'Valmistuminen', 
            fact: getStageStatusLabel(),
            condition: Boolean(viewModel.stageStatus) 
        }
    ];

    const renderFactsByOrder = (factOrder: string[]) => {
        let factIndex = 0;
        return factOrder.map((key, index) => {
            const fact = facts.find(f => f.key === key);
            if (!fact || !fact.condition) return null;
            factIndex++;

            return (
                <QuickFactsItem
                    key={fact.key}
                    index={index.toString()}
                    devCounter={fact.devCounter}
                    itemLabel={fact.label}
                    itemFact={fact.fact}
                />
            );
        })
        .filter(Boolean);
    };

    const order = [
        'nrOfParkingSpots',
        'inhabitDate',
        'minMaxPrice',
        'fiMinMaxTotalPrice',
        'address',
    ];

    return (
        <dl className="quick-facts__list">
            {renderFactsByOrder(order)}
        </dl>
    )
};